// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/SiteStoreFilters.jsx
// =============================================================================

import React from "react";

import {
  Search
} from "lucide-react";

import styles
  from "./siteStoreDashboardStyles";


// =============================================================================
// COMPONENT
// =============================================================================

export default function SiteStoreFilters({

  filters,

  projects,

  phases,

  tasks,

  onFilterChange,

  onApplyFilters

}) {

  return (

    <div style={styles.filterPanel}>


      {/* ================================================================ */}
      {/* FILTER ROW 1 */}
      {/* ================================================================ */}

      <div style={styles.filterGrid}>


        {/* PROJECT */}

        <div>

          <div style={styles.filterLabel}>

            Project

          </div>

          <select
            style={styles.select}
            value={filters.project_id}
            onChange={(e) =>
              onFilterChange(
                "project_id",
                e.target.value
              )
            }
          >

            <option value="">
              ALL PROJECTS
            </option>

            {
              projects.map((project) => (

                <option
                  key={project.id}
                  value={project.id}
                >

                  {
                    project.project_code ||

                    project.project_name
                  }

                </option>
              ))
            }

          </select>

        </div>


        {/* PHASE */}

        <div>

          <div style={styles.filterLabel}>

            Phase / WBS

          </div>

          <select
            style={styles.select}
            value={filters.phase_id}
            onChange={(e) =>
              onFilterChange(
                "phase_id",
                e.target.value
              )
            }
          >

            <option value="">
              ALL PHASES
            </option>

            {
              phases.map((phase) => (

                <option
                  key={phase.id}
                  value={phase.id}
                >

                  {phase.name}

                </option>
              ))
            }

          </select>

        </div>


        {/* TASK */}

        <div>

          <div style={styles.filterLabel}>

            Task / WBS

          </div>

          <select
            style={styles.select}
            value={filters.task_id}
            onChange={(e) =>
              onFilterChange(
                "task_id",
                e.target.value
              )
            }
          >

            <option value="">
              ALL TASKS
            </option>

            {
              tasks.map((task) => (

                <option
                  key={task.id}
                  value={task.id}
                >

                  {task.name}

                </option>
              ))
            }

          </select>

        </div>


        {/* STOCK STATUS */}

        <div>

          <div style={styles.filterLabel}>

            Stock Status

          </div>

          <select
            style={styles.select}
            value={filters.stock_status}
            onChange={(e) =>
              onFilterChange(
                "stock_status",
                e.target.value
              )
            }
          >

            <option value="">
              ALL STATUS
            </option>

            <option value="HEALTHY">
              HEALTHY
            </option>

            <option value="LOW">
              LOW
            </option>

            <option value="CRITICAL">
              CRITICAL
            </option>

          </select>

        </div>

      </div>


      {/* ================================================================ */}
      {/* FILTER ROW 2 */}
      {/* ================================================================ */}

      <div style={styles.filterGrid}>


        {/* CATEGORY */}

        <div>

          <div style={styles.filterLabel}>

            Category

          </div>

          <input
            type="text"
            placeholder="Category..."
            value={filters.category}
            onChange={(e) =>
              onFilterChange(
                "category",
                e.target.value
              )
            }
            style={styles.input}
          />

        </div>


        {/* MATERIAL */}

        <div>

          <div style={styles.filterLabel}>

            Material ID

          </div>

          <input
            type="text"
            placeholder="Material ID..."
            value={filters.material_id}
            onChange={(e) =>
              onFilterChange(
                "material_id",
                e.target.value
              )
            }
            style={styles.input}
          />

        </div>


        {/* FROM DATE */}

        <div>

          <div style={styles.filterLabel}>

            From Date

          </div>

          <input
            type="date"
            value={filters.from_date}
            onChange={(e) =>
              onFilterChange(
                "from_date",
                e.target.value
              )
            }
            style={styles.input}
          />

        </div>


        {/* TO DATE */}

        <div>

          <div style={styles.filterLabel}>

            To Date

          </div>

          <input
            type="date"
            value={filters.to_date}
            onChange={(e) =>
              onFilterChange(
                "to_date",
                e.target.value
              )
            }
            style={styles.input}
          />

        </div>

      </div>


      {/* ================================================================ */}
      {/* SEARCH */}
      {/* ================================================================ */}

      <div style={styles.searchRow}>


        <div style={styles.searchWrap}>


          <Search
            size={16}
            color="#6b7280"
          />


          <input
            type="text"
            placeholder="Search material, code, project..."
            value={filters.search}
            onChange={(e) =>
              onFilterChange(
                "search",
                e.target.value
              )
            }
            style={styles.searchInput}
          />

        </div>


        <button
          style={styles.applyBtn}
          onClick={onApplyFilters}
        >

          Apply Filters

        </button>

      </div>

    </div>
  );
}